import { render, staticRenderFns } from "./CrowdfundingAddonCardList.vue?vue&type=template&id=277abd12&"
import script from "./CrowdfundingAddonCardList.vue?vue&type=script&lang=js&"
export * from "./CrowdfundingAddonCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports